import React, { useEffect, useState } from 'react';
import { FileOpen } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { routesName } from '../../constants/routes-name';
import { ApiManager } from '../../services/api';
import { Avatar, Collapse, Modal, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import { BreadcrumbsWrapper, SendChat } from '../../components';
import { toAbsolutePath, useQuery } from '../../constants/shared-methods';
import moment from 'moment';

function Component() {
  const { user, role } = useSelector(({ user }) => user);
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const query = useQuery();
  const mid = query.get('mid') || 1;
  const [chats, setChats] = useState([]);
  const [replying, setReping] = useState('');
  const [tender, setTender] = useState();
  const [receiver, setReceiver] = useState('');

  useEffect(() => {
    getChatsDetail();
  }, [mid]);

  useEffect(() => {
    if (chats && Array.isArray(chats) && chats.length > 0) {
      setTitle(chats[0]?.title || chats[0]?.replyTo?.title || '');
    }
  }, [chats]);

  useEffect(() => {
    if (user && chats && Array.isArray(chats) && chats.length > 0) {
      if (chats[0].sender._id !== user._id) {
        setReceiver(chats[0].sender._id);
      } else if (chats[0].receiver._id !== user._id) {
        setReceiver(chats[0].receiver._id);
      }
    }
  }, [chats, user]);

  const getChatsDetail = async () => {
    const res = await ApiManager.getChatsDetail(mid);
    if (res?.status === 200 && res?.data?.result) {
      setChats(res.data.result);
      if (Array.isArray(res.data.result) && [...res.data.result].length > 0) {
        setTender(res.data.result[0].tender);
      }
    }
  };

  const breadcrumbs = [
    { title: 'Dashboard', path: routesName.dashboard },
    { title: 'Chats', path: routesName.chats },
    { title: `${tender?.refNo} - Chat` },
  ];

  return (
    <div className="flex flex-col gap-8">
      <BreadcrumbsWrapper breadcrumbs={breadcrumbs} />
      <div className="flex flex-col gap-8">
        <div>
          <div className="flex justify-between items-center">
            <div className="text-xl font-bold">{title}</div>
          </div>

          <div className="flex flex-col py-6">
            {chats &&
              Array.isArray(chats) &&
              chats.map((item, index) => (
                <div
                  key={item._id}
                  className="border-b-gray-500 border-b-2 px-2 py-4 flex gap-2"
                >
                  <div>
                    <Avatar sx={{ width: 33, height: 33 }}>
                      {`${item?.sender?.name}`.trim().charAt(0)}
                    </Avatar>
                  </div>
                  <div className="flex-1">
                    <div className="flex flex-col">
                      <div className="text-xs flex flex-wrap justify-between">
                        <div>
                          <span className="font-bold">
                            {item?.sender?.name}
                          </span>{' '}
                          {item?.isReplyAll && <span>to All</span>}
                        </div>
                        <div>{moment(item.createdAt).fromNow()}</div>
                      </div>
                    </div>
                    <div>
                      {index === 0 && item?.replyTo && (
                        <div>"{item.replyTo.message}"</div>
                      )}
                      <div>{item.message}</div>
                    </div>

                    {item.files &&
                      Array.isArray(item.files) &&
                      item.files.length > 0 && (
                        <div className="flex flex-wrap gap-4 mt-2">
                          {[...item.files].map((item, index) => (
                            <Tooltip
                              title={toAbsolutePath(item)}
                              arrow
                              placement="top"
                            >
                              <a
                                href={toAbsolutePath(item)}
                                target="_blank"
                                className="flex flex-col w-28 px-4 py-2 rounded bg-white shadow"
                              >
                                <FileOpen sx={{ fontSize: '80px' }} />
                                <span className="truncate">
                                  {toAbsolutePath(item)}
                                </span>
                              </a>
                            </Tooltip>
                          ))}
                        </div>
                      )}
                  </div>
                </div>
              ))}

            <div className="mt-4">
              <Collapse orientation="vertical" in={!replying} collapsedSize={0}>
                <div className="flex gap-3 flex-wrap">
                  <button
                    onClick={() => setReping('me')}
                    className="text-sm bg-main text-white text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                  >
                    Reply
                  </button>

                  <button
                    onClick={() => setReping('all')}
                    className="text-sm bg-main text-white text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                  >
                    Reply All
                  </button>
                </div>
              </Collapse>

              <Collapse
                orientation="vertical"
                in={!!replying}
                collapsedSize={0}
              >
                <SendChat
                  replyTo={mid}
                  replying={replying}
                  tender={tender}
                  receiver={receiver}
                  onSuccess={() => {
                    setReping('');
                    getChatsDetail();
                  }}
                  onCancel={() => {
                    setReping('');
                  }}
                />
              </Collapse>
            </div>
          </div>
        </div>
      </div>

      {/* <Modal
        open={replying}
        onClose={() => {
          setReping('');
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minWidth: 300,
            bgcolor: '#fff',
            borderRadius: '10px',
            boxShadow: 24,
            p: 2,
          }}
        >
          <SendChat
            replyTo={mid}
            replying={replying}
            tender={tender}
            onSuccess={() => {}}
            onCancel={() => {
              setReping('');
            }}
          />
        </Box>
      </Modal> */}
    </div>
  );
}

export default Component;
